import React, { useEffect, useMemo } from "react"
import { useDispatch, useSelector } from "react-redux"
import {
  getUserStart,
  getSubsPlanStart,
} from "store/SuperAdmin/Authentication/Users/action"
import TableContainer from "components/Common/TableContainer"
import Loader from "common/Loader"
import { Link } from "react-router-dom"
import moment from "moment"
import { CardBody, Col, Row, Badge, Card, Button } from "reactstrap"
import BackButton from "components/Common/BackButton"
const Home = () => {
  const { loading, userDetails } = useSelector(state => state.SuperUser)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getUserStart())
  }, [])

  const columns = useMemo(
    () => [
      {
        Header: "Sr No",
        accessor: "id",
        Cell: cellProps => {
          return <>{cellProps.value}</>
        },
      },
      {
        Header: "Name",
        accessor: "name",
        Cell: cellProps => {
          return <>{cellProps.value}</>
        },
      },
      {
        Header: "Phone No.",
        accessor: "phone_no",
        Cell: cellProps => {
          return <>{cellProps.value}</>
        },
      },
      {
        Header: "Email Status",
        accessor: "email_status",
        Cell: cellProps => {
          return (
            <>
              {cellProps.row.original.email_status === "Verified" ? (
                <Badge className={"badge-soft-success"}>Verified</Badge>
              ) : cellProps.row.original.email_status === "Pending" ? (
                <Badge className={"badge-soft-warning"}>Pending</Badge>
              ) : null}
            </>
          )
        },
      },
      {
        Header: "Login Count",
        accessor: "loginCount",
        Cell: cellProps => {
          return <>{cellProps.value}</>
        },
      },
      {
        Header: "Last Login",
        accessor: "lastLogin",
        Cell: cellProps => {
          return <>{moment(cellProps.value).format("DD-MM-YYYY")}</>
        },
      },
      {
        Header: "Subscription",
        Cell: cellProps => {
          return (
            <>
              <Link
                to={`/super/admin/users/plan/${cellProps.row.original.id}`}
                state={{name:cellProps.row.original.name}}
                className="btn btn-sm btn-soft-primary"
              >
                <i className="mdi mdi-eye-outline" />
              </Link>
            </>
          )
        },
      },
      {
        Header: "Employee",
        Cell: cellProps => {
          return (
            <div className="d-flex align-items-center">
              <Link to={`/super/admin/employee/${cellProps.row.original.id}`}>
                {cellProps.row.original.parent_id === null ? (
                  <Badge color="primary">
                    View
                  </Badge>
                ) : null}
              </Link>
            </div>
          )
        },
      },
      {
        Header: "Counts",
        Cell: cellProps => {
          return (
            <>
              <Link to={`/super/admin/users/counts/${cellProps.row.original.id}`}>
                {cellProps.row.original.parent_id === null ? (
                  <Badge color="warning">
                    View
                  </Badge>
                ) : null}
              </Link>
            </>
          )
        },
      },
    ],
    []
  )
  return (
    <div id="print-content">
      <div className="page-content">
        <div className="container-fluid">
          <Row>
            <Col lg="12">
              {loading ? (
                <Loader />
              ) : (
                <div>
                  <Card>
                    <CardBody>
                      <div className="d-flex align-items-center">
                        {/* <Backbtn/> */}
                        <h3 className="mb-0 card-title flex-grow-1">Users</h3>
                        <Link to={'/super/admin/view/users/subscription'}>
                        <Button className="btn btn-dark">View subscription</Button>

                        </Link>
                      </div>
                    </CardBody>
                    <CardBody>
                      <TableContainer
                        columns={columns}
                        data={userDetails?.data || []}
                        isGlobalFilter={true}
                        isAddOptions={false}
                        // handleJobClicks={handleJobClicks}
                        isJobListGlobalFilter={false}
                        isPagination={true}
                        iscustomPageSizeOptions={true}
                        isShowingPageLength={true}
                        customPageSize={10}
                        tableClass="table-bordered align-middle nowrap mt-2"
                        paginationDiv="col-sm-12 col-md-7"
                        pagination="pagination justify-content-end pagination-rounded"
                      />
                    </CardBody>
                  </Card>
                </div>
              )}
            </Col>
          </Row>
        </div>
      </div>
    </div>
  )
}

export default Home
